import styled, { css } from "styled-components";
import { ChevronUp, ChevronDown, Mouse } from "@styled-icons/boxicons-regular";
import { motion } from "framer-motion";
import { fonts } from "styles";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media screen and (max-width: 960px) {
    /* height: auto; */
  }
`;

export const Slide = styled(motion.div)`
  position: absolute;
  width: 100vw;
  height: 100vh;

  @media screen and (max-width: 960px) {
    height: 100%;
    overflow-y: auto;
  }
`;

export const IconLeft = styled(ChevronUp).attrs({ size: 32 })`
  color: white;
`;

export const IconRight = styled(ChevronDown).attrs({
  size: 32,
})`
  color: white;
`;

interface ButtonMobileProps {
  slide?: number;
}
export const ButtonPrevMobile = styled.button.attrs({
  type: "button",
})<ButtonMobileProps>`
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: center;
  top: 16px;
  z-index: 999;

  ${({ slide }) =>
    (slide === 10 || slide === 15) &&
    css`
      ${IconLeft} {
        color: black;
      }
    `}

  @media screen and (max-width: 1000px) {
    display: flex;
  }
`;

export const ButtonNextMobile = styled.button.attrs({
  type: "button",
})<ButtonMobileProps>`
  display: none;
  position: absolute;
  left: center;
  bottom: 72px;
  z-index: 999;
  background-color: white;
  padding: 10px 23px;
  max-height: 37px;
  border-radius: 18.5px;
  color: black;
  font-family: ${fonts.BentonSansMedium};
  font-size: 12px;
  line-height: 28px;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;

  span {
    display: flex;
    font-size: 14px;
    margin-right: 9px;
  }

  ${({ slide }) =>
    (slide === 10 || slide === 15) &&
    css`
      color: white;
      background-color: black;
    `}

  @media screen and (max-width: 1000px) {
    display: flex;
  }

  @media screen and (max-width: 320px) {
    bottom: 16px;
  }
`;

export const ScrollInfoWrapper = styled.div`
  width: 100%;
  max-width: max-content;
  background-color: #ebebeb;
  position: absolute;
  bottom: 48px;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 28px;
  border-radius: 32px;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

export const ScrollInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 22px;
  font-family: ${fonts.BentonSansRegular};
  letter-spacing: 1px;
  color: black;
  text-transform: uppercase;
  pointer-events: none;
`;

export const IconMouse = styled(Mouse).attrs({ size: 20 })`
  color: black;
  margin-right: 8px;
  transition: 300ms;
  animation-name: jump;
  animation-duration: 700ms;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-fill-mode: both;
  animation-iteration-count: infinite;

  @keyframes jump {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-5px);
    }
  }
`;
